module.exports = __webpack_public_path__ + "img/creche.e8f905ec.jpg";